import get from "lodash/get";
import userLanguageSelector from "./userLanguageSelector";

export default link =>
  get(link, `localizationMap.${userLanguageSelector()}.title`) ||
  link.title;
